/**
 * サンプルクラス
 * @constructor
 */
class SelectorForm {
  constructor() {

  }
  /**
   * サンプル
   */
  init() {
    let ch = 'chinese',
        th = 'thai',
        vi = 'vietnamese',
        urlAw = '/saran/global/asahiwrap/',
        urlCp = '/saran/global/cookper/';
    
    $('#j-headConts__lang').on('change', (e) => {
      var val = $(e.currentTarget).val();
      if (val == ch) {
        window.location.href = urlAw + "chinese/";
      } else if (val == vi) {
        window.location.href = urlAw + "vietnamese/";
      } else if (val == th) {
        window.location.href = urlAw + "thai/";
      } else {
        window.location.href = urlAw + "english/";
      }
    });
    $('#j-headConts__lang2').on('change', (e) => {
      var val = $(e.currentTarget).val();
      if (val == ch) {
        window.location.href = urlCp + "chinese/";
      } else if (val == vi) {
        window.location.href = urlCp + "vietnamese/";
      } else if (val == th) {
        window.location.href = urlCp + "thai/";
      } else {
        window.location.href = urlCp + "english/";
      }
    });
  }
};

export default SelectorForm;
